export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5041.d6f32e9f.jpg";